"use client";

import { useLang } from "@/hooks/use-lang";

import { ArticleInfo } from "../../services/article-info";

export const HeadingLinks = ({
  content,
}: {
  content: ArticleInfo["content"];
}) => {
  const { t } = useLang();
  const links =
    content?.blocks?.filter(
      (block) =>
        block.type === "header" &&
        (block.data.level === 2 || block.data.level === 3)
    ) ?? [];

  const onClick = ({ index }: { index: number }) => {
    const headerElement = document.querySelectorAll(
      "[class*='header2'], [class*='header3']"
    )[index];
    headerElement?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return links.length ? (
    <div
      className="sticky top-10 max-h-[calc(100svh-300px)] space-y-4 overflow-y-auto overscroll-none rounded-lg border-2 border-zinc-500 bg-zinc-50 p-2 text-base font-bold text-zinc-500"
      aria-label="Article headings"
    >
      <p className="text-base">{t.blog.summary}</p>
      <ol className="list-outside list-none space-y-2 pl-6 text-sm">
        {links.map((link, index) => {
          const text = link.data.text?.replace(/<[^>]*>/g, "");
          return (
            <li key={index} className={link.data.level === 3 ? "pl-5" : ""}>
              <span
                className="cursor-pointer text-zinc-500"
                onClick={() => onClick({ index })}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </li>
          );
        })}
      </ol>
    </div>
  ) : null;
};
